"use client";

import type * as React from "react";
import { useState } from "react";
import { BookingLocationSelect } from "@/components/booking/BookingLocationSelect";
import { BookingReturnLocationPicker } from "@/components/booking/BookingReturnLocationPicker";
import { Button } from "@/components/ui/button";
import { LucidePlus } from "lucide-react";

export type BookingPickupReturnFieldsProps = {
  pickupLocation?: string;
  onPickupLocationChange?: (value: string) => void;
  returnLocation?: string;
  onReturnLocationChange?: (value: string) => void;
  differentReturn?: boolean;
  onDifferentReturnChange?: (value: boolean) => void;
};

export const BookingPickupReturnFields: React.FC<
  BookingPickupReturnFieldsProps
> = ({
  pickupLocation: controlledPickup,
  onPickupLocationChange,
  returnLocation: controlledReturn,
  onReturnLocationChange,
  differentReturn: controlledDifferentReturn,
  onDifferentReturnChange,
}) => {
  const [internalPickup, setInternalPickup] = useState("");
  const [internalReturn, setInternalReturn] = useState("");
  const [internalDifferentReturn, setInternalDifferentReturn] = useState(false);
  const [returnPopoverOpen, setReturnPopoverOpen] = useState(false);

  const pickupLocation = controlledPickup ?? internalPickup;
  const setPickupLocation = onPickupLocationChange ?? setInternalPickup;
  const returnLocation = controlledReturn ?? internalReturn;
  const setReturnLocation = onReturnLocationChange ?? setInternalReturn;
  const differentReturn = controlledDifferentReturn ?? internalDifferentReturn;
  const setDifferentReturn =
    onDifferentReturnChange ?? setInternalDifferentReturn;

  const handleDifferentReturnClick = () => {
    setDifferentReturn(true);
    setReturnPopoverOpen(true);
  };

  const handleReturnAtPickup = () => {
    setDifferentReturn(false);
    setReturnLocation("");
    setReturnPopoverOpen(false);
  };

  return (
    <>
      <div>
        <label className="block mb-1 text-sm font-medium text-heading">
          {differentReturn ? "Pickup" : "Pickup & return"}
        </label>
        <BookingLocationSelect
          id="pickup-location"
          value={pickupLocation}
          onValueChange={setPickupLocation}
        />
      </div>
      <div>
        {differentReturn ? (
          <>
            <label className="block mb-1 text-sm font-medium text-heading">
              Return
            </label>
            <BookingReturnLocationPicker
              id="return-location"
              pickupLocation={pickupLocation}
              value={returnLocation}
              onValueChange={setReturnLocation}
              open={returnPopoverOpen}
              onOpenChange={setReturnPopoverOpen}
              onReturnAtPickup={handleReturnAtPickup}
            />
          </>
        ) : (
          <Button
            type="button"
            variant="ghost"
            className="mt-8"
            onClick={handleDifferentReturnClick}
          >
            <LucidePlus size={16}/>
            Different return location
          </Button>
        )}
      </div>
    </>
  );
};
